/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AgentChatDeleteResponse {
    getFixupPrototypeFunction() { return AgentChatDeleteResponse.fixupPrototype; }

    static newInstance(model: Partial<AgentChatDeleteResponse>): AgentChatDeleteResponse {
        let obj = Object.assign(new AgentChatDeleteResponse(), model);
        AgentChatDeleteResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AgentChatDeleteResponse>): AgentChatDeleteResponse {
        if (!model) return null;
        return AgentChatDeleteResponse.newInstance(<AgentChatDeleteResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AgentChatDeleteResponse) {
        if (!obj) return;

        models.AgentChatDeleteResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AgentChatDeleteResponse): boolean {
        Object.setPrototypeOf(obj, AgentChatDeleteResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.results) {
            for (let key in this.results) {
                let val = this.results[key];
                if (val) {
                    models.AgentChatDelete.fixupPrototype(val);
                }
            }
        }
    }

    /**
     * Map from identifier to response model
     */
    results: { [key: string]: models.AgentChatDelete; };

}
